import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import { AppType } from '../../App/reducer';
import Header from '../../../components/MenuManager/Header';
import RoutesUtils from '../../../utils/routes';
import { getHeaderMenuModes } from '../constants';

const mapStateToProps = (state: StoreState) => {
	const { galleryInfos, menuManager, routerParamsHistory, authentication, appInfos, search, sharePanel } = state;
	const galleryConfig = galleryInfos.config;
	const sharedMethods = galleryInfos.template && galleryInfos.template.sharedMethods;

	const menuModes = getHeaderMenuModes(search, sharePanel, menuManager.menuModes);
	const { needCredentials } = authentication.userInfos;
	const { origin } = routerParamsHistory[routerParamsHistory.length - 1].params;
	const type = appInfos.type || AppType.Single;
	const isDownloadable = sharedMethods && sharedMethods.includes(Api.ShareMethod.Download);
	const isMultiApp = Utils.isMultiApp(appInfos);

	// Secured galleries can't share the root gallery
	const isSecure = Utils.isSecure(type, needCredentials);
	const isGalleryRoot = RoutesUtils.isGalleryRoot(routerParamsHistory);
	const isShareable = sharedMethods && sharedMethods.includes(Api.ShareMethod.Share) && !(isGalleryRoot && isSecure);

	return { galleryConfig, menuModes, isShareable, isDownloadable, origin, isMultiApp };
};

export default connect(mapStateToProps)(Header);




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/index.tsx